"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFormPublicView = void 0;
var React = require("react");
var constants_1 = require("./constants");
exports.CardFormPublicView = function (props) { return (React.createElement("iframe", { ref: props.iframeRef, src: props.url, "data-hook": constants_1.formIframeDataHook, scrolling: "no", style: {
        width: '100%',
        height: props.height + "px",
        border: 'none',
    } })); };
exports.CardFormPublicView.displayName = 'CardFormPublicView';
//# sourceMappingURL=view.js.map